<template>
  <Drawer
    placement="right"
    :closable="false"
    title="历史登录用户"
    width="240"
    v-model="openForm"
    draggable
    @on-close="close"
  >
    <ul id="mordAcountid">
      <li v-for="(row, index) in tableData" :key="index">
        <span @click="select(row)">{{ row.username }}</span>

        <Icon @click="delconfirm(row.username)" type="md-close"></Icon>
      </li>
    </ul>
  </Drawer>
</template>
<script>
export default {
  data() {
    return {
      openForm: false,
      columns: [
        {
          title: "用户名",
          slot: "username",
        },
        {
          title: "最近登录",
          key: "time",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.time));
          },
        },
        {
          title: "删除记录",
          slot: "action",
        },
      ],
      tableData: [],
      cookey: this.axios.plat + "users",
    };
  },
  methods: {
    reach() {
      this.openForm = true;
      var msyy = JSON.parse(localStorage.getItem(this.cookey));
      console.log(msyy);
      if (msyy != null) {
        this.tableData = msyy;
      } else {
        this.tableData = [];
      }
    },
    save(v) {
      console.log(v);
      v.time = Date.now();
      if (this.look(v)) {
        this.del(v.username);
        this.tableData.unshift(v);
      } else {
        this.tableData.unshift(v);
      }
      localStorage.setItem(this.cookey, JSON.stringify(this.tableData));
      //localStorage.removeItem(this.cookey);
    },
    //判断是否存在
    look(v) {
      this.tableData = JSON.parse(localStorage.getItem(this.cookey));
      if (this.tableData == null) {
        this.tableData = [];
      }
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].username == v.username) {
          return true;
        }
      }
    },
    select(v) {
      if (v) {
        this.$emit("msg", v);
      } else {
        this.$emit("msg");
      }

      this.openForm = false;
    },
    del(username) {
      for (let i = 0; i < this.tableData.length; i++) {
        if (username == this.tableData[i].username) {
          this.tableData.splice(i, 1);
        }
      }
      localStorage.setItem(this.cookey, JSON.stringify(this.tableData));
    },
    delconfirm(username) {
      this.$Modal.confirm({
        title: "是否删除记录？",
        content: "该删除只是本地删除，不会影响服务器数据",
        onOk: () => {
          this.del(username);
        },
      });
    },
    close() {
      this.select(this.tableData[0]);
    },
  },
  mounted() {
    var msyy = JSON.parse(localStorage.getItem(this.axios.plat + "login"));
    if (msyy != null) {
      this.tableData.push(msyy);
      localStorage.setItem(this.cookey, JSON.stringify(this.tableData));
      localStorage.removeItem(this.axios.plat + "login");
    }
    this.tableData = JSON.parse(localStorage.getItem(this.cookey));
    if (this.tableData==null) {
      this.tableData=[];
    }
    this.select(this.tableData[0]);

  },
};
</script>
<style>
#mordAcountid {
  height: 100%;
  overflow: auto;
}
#mordAcountid li {
  display: flex;
  padding: 4px;
}
#mordAcountid li:hover {
  background: #ebf5ff;
  cursor: pointer;
}

#mordAcountid li span {
  width: calc(100% - 16px);
}
#mordAcountid li i {
  width: 16px;
  color: #ccc;
}
#mordAcountid li i:hover {
  color: red;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/sys/moreAcount.vue